import LinkNext from 'next/link';
import * as S from './styles';
import { CSSProperties } from 'styled-components';

export type LinkSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export type LinkWeight = 'light' | 'regular' | 'medium' | 'bold';
export type LinkTrim = 'normal' | 'start' | 'end' | 'both';

export type LinkProps = {
  $size: LinkSize;
  $weight: LinkWeight;
  $underline: boolean;
  $highContrast: boolean;
  $color: string;
  $text: string;
  $active?: boolean;
  href: string;
  $onClick?: () => void;
  $abrirNovaGuia?: boolean;
  style?: CSSProperties;
};

export default function Link(props: LinkProps) {
  const {
    href,
    $text,
    $active = true,
    $onClick = undefined,
    $abrirNovaGuia = false,
    style = {},
  } = props;

  if ($abrirNovaGuia) {
    return (
      <LinkNext
        href={href}
        style={{
          pointerEvents: $active ? 'auto' : 'none',
        }}
        passHref
        legacyBehavior
        onClick={$onClick}
      >
        <a style={style} target="_blank">
          <S.LinkEstilizado style={style} {...props}>
            {$text}
          </S.LinkEstilizado>
        </a>
      </LinkNext>
    );
  }
  return (
    <LinkNext
      href={href}
      style={{
        pointerEvents: $active ? 'auto' : 'none',
        textDecoration: 'none',
        ...style,
      }}
      onClick={$onClick}
    >
      <S.LinkEstilizado style={style} {...props}>
        {$text}
      </S.LinkEstilizado>
    </LinkNext>
  );
}
